import React from 'react'

import { useIntl } from '@app/intl/Intl'
import { bemJoin } from '@app/lib/bem'

import './ProductType.scss'

export type ProductTypeProps = {
  uid?: string | null
  displayName?: string | null
}

export const ProductType = ({ uid, displayName }: ProductTypeProps) => {
  const b = bemJoin('product-type')
  const { formatMessage } = useIntl()

  const isMembershipTypeUid = uid?.includes('.')

  const partner = uid?.includes('mieterengel') ? null : uid?.split('.')[0]

  return (
    <div className={b()}>
      <div className={b('icon')}>
        {isMembershipTypeUid && partner && (
          <img
            src={`${process.env.REACT_APP_AWS_ASSET_BUCKET_URL}/partner-logos/${partner}-mini.svg`}
            alt='partner logo'
          />
        )}
      </div>
      <div className={b('name')}>{displayName ?? formatMessage({ id: 'ProductType.Unknown' })}</div>
    </div>
  )
}
